import { render, staticRenderFns } from "./struktur.vue?vue&type=template&id=39c6c8dc&"
import script from "./struktur.vue?vue&type=script&lang=js&"
export * from "./struktur.vue?vue&type=script&lang=js&"
import style0 from "./struktur.vue?vue&type=style&index=0&id=39c6c8dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports